export const getAddress = () => {
  let user = window.sessionStorage.getItem('user')
  user = (user && JSON.parse(user)) || {}
  return user.address
}

export const getFavorites = () => {
  let favorites = window.localStorage.getItem('favorites')
  favorites = (favorites && JSON.parse(favorites)) || {
    favorites_logined: [],
    favorites_unLogined: [],
  }

  return favorites
}

export const getInitialFavorites = () => {
  const address = getAddress()
  const favorites = getFavorites()
  let result = favorites.favorites_unLogined
  if (address) {
    result = favorites.favorites_logined?.find(f => f[address]?.length > 0)
    return result ? result[address] : []
  }
  return result
}
